import React, { useContext, useState } from "react";
import OrderPane from "../form/order/OrderPane";
import SopotakContext from "../../store/sopotak-context";
import ContactPane from "../form/contact/ContactPane";
import OrderSummaryPane from "../form/summary/OrderSummaryPane";
import SearchWidget from "../form/search/SearchWidget";
import SummaryAndContact from "../form/SummaryAndContact";

function OrderPage() {
  const ctx = useContext(SopotakContext);
  const [step, setStep] = useState(1);

  function handleProgress(stepNumber) {
    setStep(stepNumber);
  }

  return (
    <div style={{padding: "1rem"}}>
      {step === 1}
      {/*<ProgressSteps step={step} />*/}

      {step === 1 && <SearchWidget mainPage={false} />}

      <div className="form-pane-wrapper">
        {step === 1 && <OrderPane progressHandler={handleProgress} />}
        {step === 2 && <SummaryAndContact progressHandler={handleProgress} />}
        {/* {step === 3 && <OrderSummaryPane progressHandler={handleProgress} />} */}
      </div>
    </div>
  );
}

export default OrderPage;
